import { useState } from 'react';
import clsx from 'clsx';
import styles from './CollapsableHeader.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import { IoIosArrowDown } from 'react-icons/io';

function CollapsableHeader({
  className,
  heading,
  children,
  defaultOpen = true,
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={clsx(styles.CollapsableHeaderWrapper, className)}>
      <div
        className={styles.CollapsableHeader}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h4 className={styles.heading}>{heading}</h4>

        <motion.span
          className={styles.icon}
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.25 }}
        >
          <IoIosArrowDown />
        </motion.span>
      </div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            className={styles.content}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <div className={styles.innerContent}>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default CollapsableHeader;
